import { WorkflowActionEndpoints } from '@/modules/seller-management/workflow-action/api/workflowActionEndpoints'

/**
 * Workflow Action endpoint instance
 * instantiate Workflow Action api class with a different api path
 */
export const workflowActionEndpoints = new WorkflowActionEndpoints()
